var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "document-folder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document-folder",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(5.000000, 5.000000)",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-7",
    stroke: "#000000",
    fill: "#2F88FF",
    fillRule: "nonzero",
    x: 18,
    y: 1,
    width: 10,
    height: 36
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-7-Copy",
    stroke: "#000000",
    fill: "#2F88FF",
    fillRule: "nonzero",
    x: 28,
    y: 1,
    width: 10,
    height: 36
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-7-Copy-2",
    stroke: "#000000",
    fill: "#2F88FF",
    fillRule: "nonzero",
    points: "3.5 0 14 0.840909091 10.5 37 0 36.1590909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,13 L33,10",
    id: "Path-17-Copy-5",
    stroke: "#FFFFFF",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,13 L23,10",
    id: "Path-17-Copy-5",
    stroke: "#FFFFFF",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplate);
export default __webpack_public_path__ + "static/media/template.0bd03b2a8af61040999194c0e1266ff5.svg";
export { ForwardRef as ReactComponent };